export default __webpack_public_path__ + "static/media/vrtgallery_demo_image.82752046.png";